import React from "react";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import Button from "../../../components/ui/Button";

interface TableExportProps {
  onExport: () => void;
}

const TableExport: React.FC<TableExportProps> = ({ onExport }) => {
  return (
    <Button variant="text" size="md" onClick={onExport} title="Export table as CSV">
      <span className="flex items-center gap-2">
        <ArrowDownTrayIcon className="w-3.5 h-3.5" />
        <span>Export CSV</span>
      </span>
    </Button>
  );
};

export default TableExport;
